import React from "react";
import "./CenterBox.scss"; // Import the SCSS file

export default function CenterBox({ children }) {
  return (
    <div className="center-box-container">
      <div className="center-box-wrapper">
        <div className="center-box-content">
          {children}
        </div>
      </div>
    </div>
  );
}